import helper from "@/store/helpers/helper";
// будет работать, только если в контексте компонента лежит item.icon
export function checkSocialLink (value) {
  return helper.checkLink(value, this.item.icon).isValid
}